'use strict';

var AttachmentModalCtrl = function (attachment, office, services, gettextCatalog, OfficeDA, Notification, modalInstance) {
    this._modalInstance = modalInstance;
    this._Notification = Notification;
    this._OfficeDA = OfficeDA;
    this.gettextCatalog = gettextCatalog;
    this.attachment = attachment;
    this.office = office;
    this.showWrongFileTypeError = false;
    this.showMissingFileError = false;
    this.file = null;
    this.services = services;
    this.selectedService = null;
    this.selectedCustomField = null;
    this.customFieldValue = null;
    this.customFields = [];
    this.formSubmitted = false;

    if (office.settings.customFields?.customer) {
        office.settings.customFields.customer.forEach((customField) => {
            if (customField.booking) {
                this.customFields.push({
                    dest: 'customer',
                    ...customField
                });
            }
        });
    }

    if (office.settings.customFields?.appointment) {
        office.settings.customFields.appointment.forEach((customField) => {
            if (customField.booking) {
                this.customFields.push({
                    dest: 'appointment',
                    ...customField
                });
            }
        });
    }

    if (this.attachment) {
        this.file = {
            name: this.attachment.originalFileName,
        };

        if (this.attachment.conditions && this.attachment.conditions.length) {
            this.attachment.conditions.forEach((condition) => {
                switch (condition.data) {
                    case 'service':
                    case 'servicegroup':
                        this.selectedService = this.services[condition.value];
                        break;
                    case 'customFieldCustomer':
                        this.selectedCustomField = this.customFields.find((customField) => {
                            return customField.name === condition.key && customField.dest === 'customer';
                        });
                        if (condition.value) {
                            this.customFieldValue = condition.value;
                        }
                        break;
                    case 'customFieldAppointment':
                        this.selectedCustomField = this.customFields.find((customField) => {
                            return customField.name === condition.key && customField.dest === 'appointment';
                        });
                        if (condition.value) {
                            this.customFieldValue = condition.value;
                        }
                        break;
                }
            });
        }
    }
};

AttachmentModalCtrl.prototype.abort = function () {
    this._modalInstance.close('abort');
};

AttachmentModalCtrl.prototype.customFieldSelected = function () {
    this.customFieldValue = null;
};

AttachmentModalCtrl.prototype.selectFile = function (files) {
    const file = files && files.length ? files[0] : null;

    if (file) {
        if (file.type !== 'application/pdf') {
            this.showWrongFileTypeError = true;
            this.file = null;
        } else {
            this.showWrongFileTypeError = false;
            this.file = file;
        }
    }
};

AttachmentModalCtrl.prototype.save = function () {
    const conditions = [];

    this.formSubmitted = true;

    if (!this.file) {
        this.showMissingFileError = true;
        return;
    } else {
        this.showMissingFileError = false;
    }

    if (!this.form.$valid) {
        return;
    }

    if (this.selectedService) {
        if (this.selectedService.type === 'service') {
            conditions.push({
                name: this.selectedService.name,
                data: 'service',
                key: '_id',
                value: this.selectedService._id
            });
        }

        if (this.selectedService.type === 'group') {
            conditions.push({
                name: this.selectedService.name,
                data: 'servicegroup',
                key: '_id',
                value: this.selectedService._id
            });
        }
    }

    if (this.selectedCustomField && this.customFieldValue) {
        if (this.selectedCustomField.dest === 'customer') {
            conditions.push({
                name: this.selectedCustomField.label,
                data: 'customFieldCustomer',
                key: this.selectedCustomField.name,
                value: this.customFieldValue
            });
        }

        if (this.selectedCustomField.dest === 'appointment') {
            conditions.push({
                name: this.selectedCustomField.label,
                data: 'customFieldAppointment',
                key: this.selectedCustomField.name,
                value: this.customFieldValue
            });
        }
    }

    if (this.attachment) {
        this._OfficeDA
            .editAttachment(this.attachment._id, {conditions})
            .then((response) => {
                this._Notification.addSuccessMessage(this.gettextCatalog.getString('Attachment edited'));
                this._modalInstance.close(response);
            })
            .catch((response) => {
                this._Notification.addErrorMessage({text: response.data.error.message});
            });
    } else {
        this._OfficeDA
            .uploadAttachment(this.file, {conditions})
            .then((response) => {
                this._Notification.addSuccessMessage(this.gettextCatalog.getString('Attachment uploaded'));
                this._modalInstance.close(response);
            })
            .catch((response) => {
                if (response.data.error.message === 'file_to_large') {
                    this._Notification.addErrorMessage(this.gettextCatalog.getString('File is to large (max 10 MB)'));
                } else if (response.data.error.message === 'extension_not_allowed') {
                    this._Notification.addErrorMessage(this.gettextCatalog.getString('File extension not of type [PDF]'));
                } else {
                    this._Notification.addErrorMessage({text: response.data.error.message});
                }
            });
    }
};

module.exports = AttachmentModalCtrl;
